import { render, unmountComponentAtNode } from 'react-dom'
import { Toast } from './Toast'
import * as Sentry from '@sentry/react'

class ToastService {
  constructor () {
    this.inited = false
  }
  
  show (props) {
    clearTimeout(this.timeoutHandler)
    this.timeoutHandler = setTimeout(() => this.hide(), props.duration || 5000)

    render(<Sentry.ErrorBoundary fallback={<></>}>
      <Toast id='toast' {...props} hide={() => {
        this.hide()
      }}
       ></Toast>
    </Sentry.ErrorBoundary>,
    document.getElementById('appToastContainer')
    )
  }

  hide () {
    const toastElement = document.getElementById('toast')
    if (!toastElement) return
    unmountComponentAtNode(
      toastElement.parentNode,
    )
  }
}

export default new ToastService()
